import { Component, Input } from '@angular/core';
import { ContentService } from 'src/app/services/content.service';
import { PlayerSessionService } from 'src/app/services/player-session.service';
import { PlayerService } from 'src/app/services/player.service';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-shape-component',
  templateUrl: './shape-component.component.html',
  styleUrls: ['./shape-component.component.scss'],
})
export class ShapeComponentComponent {
  @Input() component: any;

  constructor(
    public statesService: StatesService,
    public contentService: ContentService
  ) {}
  ngOnInit(): void {}

  onMouseDown() {
    this.statesService.onMouseDown(this.component);
  }
  onMouseUp() {
    this.statesService.onMouseUp(this.component);
  }

  onMouseEnter() {
    this.statesService.onMouseEnter(this.component);
  }
  onMouseLeave() {
    this.statesService.onMouseLeave(this.component);
  }
}
